import { createDirtyChecker, compareByPaths } from "../gvc/testNewForm/createDirtyChecker";
import { inputToUser } from "./utils";

export function getDirtyChecker(id: string) {
  return createDirtyChecker(id, inputToUser, compareByPaths({
    tags: { path: "tags" },
  }));
}
